<template>
  <Widget width="335" height="335">
    <Clock />
  </Widget>
</template>

<script>
import Widget from '../Widget.vue';
import Clock from './Clock.vue';

export default {
  components: { Clock, Widget }
}
</script>